module.exports = __webpack_public_path__ + "static/changes-in-the-land-cefe6e04a2620d5eef9abadc93eb6bfb.jpg";